/* eslint-disable function-paren-newline */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { initialiser } from '../../ramen-imports/utilitybelt';

import App from './containers/App.jsx';
import { store } from './store';

class EventSchedule {
  constructor({ el }) {
    this.container = el;
  }

  init = () => {
    const {
      ad1, ad2, adBasement, currentTimeOverride, descriptionSaved, descriptionSchedule, descriptionShared, logoAlt, logoText, logoUrl, sideImage, shareEmail, shareEnabled, shareFacebook, shareReddit, shareTwitter, // eslint-disable-line max-len
    } = this.container.dataset;

    const root = createRoot(this.container);

    const getAds = () => {
      const adArray = [];
      if (typeof ad1 === 'string' && ad1) adArray.push(ad1);
      if (typeof ad2 === 'string' && ad2) adArray.push(ad2);
      return adArray;
    };

    const getShareWidgetKeys = () => {
      if (shareEnabled) {
        const keys = [];

        if (shareEmail) keys.push('email');
        if (shareFacebook) keys.push('facebook');
        if (shareReddit) keys.push('reddit');
        if (shareTwitter) keys.push('twitter');

        return keys;
      }

      return [];
    };

    root.render(
      <React.StrictMode>
        <Provider store={store}>
          <App
            adBasement={adBasement}
            ads={getAds()}
            currentTimeOverride={currentTimeOverride}
            descriptionSaved={descriptionSaved}
            descriptionSchedule={descriptionSchedule}
            descriptionShared={descriptionShared}
            logoAlt={logoAlt}
            logoText={logoText}
            logoUrl={logoUrl}
            shareWidgetKeys={getShareWidgetKeys()}
            sideImage={sideImage}
          />
        </Provider>
      </React.StrictMode>,
    );
  };
}

// Export component wrapped in initialiser utility
export default (settings) => initialiser(settings, EventSchedule);
